import React from 'react';
import classnames from 'classnames';
import { node, string } from 'prop-types';

const DisplayField = ({
  children,
  label,
  title,
  className,
  ...props
}) => (
  <div
    className={classnames(
      'mdc-form-field',
      className,
    )}
    {...props}
  >
    {
      // eslint-disable-next-line jsx-a11y/label-has-for
      <label
        title={title || label}
        role="presentation"
        className="mdc-form-field-label"
      >{label}
      </label>
    }
    <div className="mdc-form-field-display">{children || '-'}</div>
  </div>
);


DisplayField.propTypes = {
  children: node,
  label: node,
  className: string,
  title: string,
};

DisplayField.defaultProps = {
  children: null,
  className: null,
  label: null,
};

export default DisplayField;
